__webpack_require__.p = "https://cdn.beta.schoolblocks.com/assets/_next/";